/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

document.addEventListener("DOMContentLoaded", function () {
  const cartElements = document.querySelectorAll('.sp-cart');
  cartElements.forEach(element => {
    element.addEventListener('click', function () {
      window.location.href = '/cart';
    });
  });
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      // 原来的倒计时
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
      $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);

      // 新的顶部渐变条倒计时
      $(".sp-product-top-bar .sp_hour").html(cutDownTimeText.hour);
      $(".sp-product-top-bar .sp_minute").html(cutDownTimeText.minute);
      $(".sp-product-top-bar .sp_second").html(cutDownTimeText.second);
    }, 1000);
  }

  getCutDownTime();



  new Swiper(".sp-swiper-fade-top", {
    spaceBetween: 10,
    effect: "fade",
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  });

  // new Swiper(".sp-btn-style1 .swiper", {
  //   spaceBetween: 10,

  //   autoplay: true,
  //   autoplay: {
  //     disableOnInteraction: false,
  //   },
  //   loop: true,
  // });

  let _spswiper2 = new Swiper(".sp-swiper2", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },

    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    on: {
      slideChange: function (e) {
        $("#sp_btns .sp-p")
          .eq(e.realIndex)
          .addClass("sp-active")
          .siblings()
          .removeClass("sp-active");
      },
    },
  });
  // 点击切换轮播
  $("#sp_btns .sp-p").click(function () {
    $(this).addClass("sp-active").siblings().removeClass("sp-active");
    _spswiper2.slideToLoop($(this).index());
  });

  let _spswiper2m = new Swiper(".sp-swiper2-m", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },

    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: ".sp-swiper-btn-next-m",
      prevEl: ".sp-swiper-btn-prev-m",
    },
    pagination: {
      el: ".sp-pagination-m",
      clickable: true,
    },
    on: {
      slideChange: function (e) {
        $("#sp_btnsm .sp-p")
          .eq(e.realIndex)
          .addClass("sp-active")
          .siblings()
          .removeClass("sp-active");
      },
    },
  });

  // 点击切换轮播
  $("#sp_btnsm .sp-p").click(function () {
    $(this).addClass("sp-active").siblings().removeClass("sp-active");
    _spswiper2m.slideToLoop($(this).index());
  });

  let _swiper = new Swiper(".sp-swiper-pro", {
    speed: 1,
    spaceBetween: 0,
  });

  // 移动端 FREE-COULD Cloud 轮播
  new Swiper(".sp-cloud-swiper", {
    spaceBetween: 50,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 500,
    pagination: {
      el: ".sp-cloud-pagination",
      clickable: true,
    },
  });

  // PC端 DPW 图片轮播 - 渐现效果
  new Swiper(".sp-dpw-swiper", {
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 1000,
    allowTouchMove: false,
  });

  // PC端第四板块轮播图
  new Swiper(".sp-section4-swiper-pc", {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 500,
    pagination: {
      el: ".sp-section4-pagination-pc",
      clickable: true,
    },
  });

  // 移动端第四板块轮播图
  new Swiper(".sp-section4-swiper-mobile", {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 500,
    pagination: {
      el: ".sp-section4-pagination-mobile",
      clickable: true,
    },
  });

  // 移动端 DPW 图片轮播 - 渐现效果
  new Swiper(".sp-dpw-swiper-mobile", {
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 1000,
    allowTouchMove: false,
  });

  // 移动端人头图片轮播 - 渐现效果
  new Swiper(".sp-cloud-person-swiper", {
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 1000,
    allowTouchMove: false,
  });

  $(" .sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    let colorOptions = $(" .sp-color .sp-option.active").index();
    let numOptions = $(" .sp-num .sp-option.active").index();

    _index = numOptions;

    // $(".sp_product_part.sp_mobile .sp-img-p")
    //   .eq(_index)
    //   .addClass("active")
    //   .siblings()
    //   .removeClass("active");
    _swiper.slideToLoop(_index);
  });

  jQuery(".sp-scroll2").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
              }
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
        config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();



    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop =
          document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $(".sp-nav").height()
            : targetElement.offsetTop;

        let sptop = document.body.clientWidth <= 1080 ? 70 : 65;

        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            sptop * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        });
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();



  // 更新产品图片显示 - 根据颜色和数量选项
  function updateProductImageBySelection() {
    changePrice()
    var $allImages = $('.sp-new-style .sp-product-img');
    var $container = $('.sp-new-style .sp-product-img-container');
    $allImages.removeClass('active');

    // 移除所有cantidad类名，添加当前选项的类名
    $container.removeClass('cantidad-1 cantidad-2 cantidad-3');
    $container.addClass('cantidad-' + currentCantidadIndex);

    // 根据当前颜色和Cantidad选项找到对应的图片
    // data-color: 颜色索引 1-3
    // data-qty: 1 或 2
    // data-bundle: 1 或 2
    // Cantidad选项: 1=Comprar 1, 2=Compre 2 y llévese 1 gratis, 3=Compre 3 y llévese 2 gratis

    var qtyValue, bundleValue;
    if (currentCantidadIndex === 1) {
      qtyValue = 1;
      bundleValue = 1;
    } else if (currentCantidadIndex === 2) {
      qtyValue = 1;
      bundleValue = 2;
    } else {
      qtyValue = 2;
      bundleValue = 1;
    }

    var $targetImage = $('.sp-new-style .sp-product-img[data-color="' + currentColorIndex + '"][data-qty="' + qtyValue + '"][data-bundle="' + bundleValue + '"]');
    if ($targetImage.length) {
      $targetImage.addClass('active');
    } else {
      // 如果没找到精确匹配，只按颜色匹配
      $targetImage = $('.sp-new-style .sp-product-img[data-color="' + currentColorIndex + '"]').first();
      if ($targetImage.length) {
        $targetImage.addClass('active');
      } else {
        // 如果还是没找到，显示第一张
        $('.sp-new-style .sp-product-img').eq(0).addClass('active');
      }
    }
  }

  var currentCantidadIndex = 1; // 默认选中第一个
  var currentColorIndex = 1; // 默认选中第一个颜色
  let prods = window.product
  function getCur(){
    let option1 = $('#sp-color-img div.active').attr('data-val')
    let option2 = $('#sp-num div.active').attr('data-val')

    return prods.filter(item=> item.option1 == option1&&item.option2 == option2)[0]
  }
  function changePrice(){
    // 插件开启下墨西哥比索汇率
    // let scale = 17.9283;
    let num = $('#calcNumber').val()
    let price = (getCur().price * num  / 100).toFixed(0)
    let compare = (getCur().compare_at_price * num  / 100).toFixed(0)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    // $(".sp-price1 .cbb-price-digits").html(price)
    // $(".sp-price2 .cbb-price-digits").html(compare)
     $('#sp_price1').html(price)
     $('#sp_price2').html(compare)
    let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
    
    $(".sp_product_part .sp-discount span").html(`${off_font}`)
  }
  $('.sp-btn-style').click(function(){
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })
  // Color颜色选项点击事件
  $(document).on('click', '.sp-new-style .sp-color-option-btn', function () {
    console.log(111)
    var $this = $(this);
    var $siblings = $('.sp-new-style .sp-color-option-btn');
    var index = $siblings.index($this) + 1;

    // 更新选中状态
    $siblings.removeClass('active');
    $this.addClass('active');

    // 更新当前颜色索引
    currentColorIndex = index;

    // 更新产品图片
    updateProductImageBySelection();
  });

  // Cantidad数量选项点击事件
  $(document).on('click', '.sp-new-style .sp-option-btn', function () {
    console.log(222)
    var $this = $(this);
    var $siblings = $('.sp-new-style .sp-option-btn');
    var index = $siblings.index($this) + 1;

    // 更新选中状态
    $siblings.removeClass('active');
    $this.addClass('active');

    // 更新当前数量索引
    currentCantidadIndex = index;

    // 更新产品图片
    updateProductImageBySelection();
  });

  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice()
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice()
  });

  // 输入框直接输入时也更新价格
  $("#calcNumber").on("input change", function () {
    var num = Number($(this).val());
    if (num < 1) {
      $(this).val(1);
    }
    changePrice()
   
  });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0,
      }
    );
    observer.observe(gradually);
  }

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  // 菜单
  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask").click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $(".sp-menu-mask").hide();
    // }
  });

  // 滚动隐藏顶部
  if (
    $(window).scrollTop() >
    $(".sp_header").height() * $("div#root").css("zoom")
  ) {
    $(".sp_header-wrap").addClass("sp-fixed");
    $(".sp_pc .sp_header-content").addClass("scrolled");
  } else {
    $(".sp_header-wrap").removeClass("sp-fixed");
    $(".sp_pc .sp_header-content").removeClass("scrolled");
  }

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $(".sp_header").height() * $("div#root").css("zoom")
    ) {
      $(".sp_header-wrap").addClass("sp-fixed");
      $(".sp_pc .sp_header-content").addClass("scrolled");
    } else {
      $(".sp_header-wrap").removeClass("sp-fixed");
      $(".sp_pc .sp_header-content").removeClass("scrolled");
    }
  });

  $(document).on("click", ".sp_buy_now", function () {
    console.log("xxx111");
  });

  let initNum = 0;
  $(document).on("click", ".sp_add_cart", function () {
    // 购物车加购动效

    $(this).children("img").addClass("on");
    $(".sp-cart .num").show();
    setTimeout(function () {
      $(" .cart-btn").children("img").removeClass("on");
    }, 500);
    $(" .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-cart").removeClass("on");
    }, 500);

    // 加购成功后设置购物车数字为红底白字

    var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $(".cardNum").each(function () {
            $(this).html(result.item_count);
          });
          $(".cardNum").removeClass("sp-gray");
          $(".sp-btn-style2 .sp-cart .cardNum").addClass("sp-cart-added");
        });
      },
      dataType: "json",
    });
    // handleAddToCart(initNum);

    var imgs = $(".sp_product_part .sp-product-img.active");

    imgs.each(function () {
      var $img = $(this);
      var flyer = $img[0].cloneNode(true);
      flyer.classList.add("sp_clone");

      $(".sp_product_part").append(flyer);
      $(flyer).css({
        width: $img[0].width,
        height: $img[0].height,
        background: "#e7e9ef",
        position: "fixed",
        top: $img[0].offsetTop,
        left: $img.offset().left,
        "z-index": 9999,
      });

      if (document.body.clientWidth <= 1080) {
        // 移动端 - 定位到底部购物车
        var finish = $(".sp-bottom-cart-new.sp-fixed-bottom .sp-bottom-cart-box");
        if (finish.length === 0) {
          $(flyer).remove();
          return;
        }

        $(flyer).animate(
          {
            top: $(".sp-bottom-cart-new")[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      } else {
        // PC端 - 定位到导航栏购物车
        var finish = $(".sp_pc .sp_header-content .sp-cart");
        if (finish.length === 0) {
          $(flyer).remove();
          return;
        }

        $(flyer).animate(
          {
            top: finish[0].offsetTop,
            left: finish.offset().left + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      }
    });
  });

  // 问答 QA1
  $(".sp-qa1-faq-question").on("click", function () {
    var $currentItem = $(this).parent(".sp-qa1-faq-item");
    var $answer = $(this).next(".sp-qa1-faq-answer");
    var $icon = $(this).find(".sp-qa1-faq-icon");

    if ($currentItem.hasClass("active")) {
      $answer.slideUp(300);
      $currentItem.removeClass("active");
      $icon.attr("src", "https://cdn.shopify.com/s/files/1/0711/3211/9196/files/20251225_bb41b301-cfd5-482f-bb08-c807eade7095.png?v=1766738542");
    } else {
      $(".sp-qa1-faq-item").removeClass("active");
      $(".sp-qa1-faq-answer").slideUp(300);
      $(".sp-qa1-faq-icon").attr("src", "https://cdn.shopify.com/s/files/1/0711/3211/9196/files/20251225_bb41b301-cfd5-482f-bb08-c807eade7095.png?v=1766738542");

      $currentItem.addClass("active");
      $answer.slideDown(300);
      $icon.attr("src", "https://cdn.shopify.com/s/files/1/0711/3211/9196/files/20251225_f5ce110f-bd1d-4f79-b6b3-decf8d9543b1.png?v=1766738542");
    }
  });

  // 移动端 Tired of Slow 轮播图无缝滚动
  (function initTiredCarousel() {
    var $carousel = $(".sp-tired-carousel");
    if ($carousel.length === 0) return;

    // 复制一份内容实现无缝循环
    var $items = $carousel.children().clone();
    $carousel.append($items);

    // 支持触摸滑动
    var startX = 0;
    var scrollLeft = 0;
    var isDragging = false;

    $carousel.on("touchstart mousedown", function (e) {
      isDragging = true;
      $carousel.css("animation-play-state", "paused");
      startX = e.type === "touchstart" ? e.originalEvent.touches[0].pageX : e.pageX;
      scrollLeft = $carousel.parent().scrollLeft();
    });

    $carousel.on("touchmove mousemove", function (e) {
      if (!isDragging) return;
      e.preventDefault();
      var x = e.type === "touchmove" ? e.originalEvent.touches[0].pageX : e.pageX;
      var walk = (startX - x) * 2;
      $carousel.parent().scrollLeft(scrollLeft + walk);
    });

    $carousel.on("touchend mouseup mouseleave", function () {
      isDragging = false;
      $carousel.css("animation-play-state", "running");
    });
  })();

  // 移动端 sp-part3 菜品轮播无缝滚动（从下往上）
  (function initFoodCarousel() {
    var $carousel = $(".sp-part3-food-carousel");
    if ($carousel.length === 0) return;

    // 复制一份内容实现无缝循环
    var $items = $carousel.children().clone();
    $carousel.append($items);
  })();

  // 移动端 sp-part3 特性轮播无缝滚动（从右往左）
  (function initFeaturesCarousel() {
    var $carousel = $(".sp-part3-features-carousel");
    if ($carousel.length === 0) return;

    // 复制一份内容实现无缝循环
    var $items = $carousel.children().clone();
    $carousel.append($items);
  })();

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`;
              span.style.animationDelay = `${index * 0.3 + 1}s`;
            });

            observerAni.unobserve(gradually3);
          }
        });
      },
      {
        threshold: 0,
      }
    );
    observerAni.observe(gradually3);
  }

  // 产品选项切换功能
  (function initProductOptionSwitch() {
    // 当前选择状态
    var currentColor = 1;
    var currentQty = 1;
    var currentBundle = 1;

    // 更新产品图片显示
    function updateProductImage() {
      var $allImages = $('.sp-product-img');
      $allImages.removeClass('active');

      var $targetImage = $('.sp-product-img[data-color="' + currentColor + '"][data-qty="' + currentQty + '"][data-bundle="' + currentBundle + '"]');
      $targetImage.addClass('active');
    }

    // 颜色选项点击事件
    $(document).on('click', '#sp-color-img .sp-color-option', function () {
      var $this = $(this);
      var $siblings = $('#sp-color-img .sp-color-option');
      var index = $siblings.index($this) + 1;

      // 更新选中状态
      $siblings.removeClass('active');
      $this.addClass('active');

      // 更新当前颜色
      currentColor = index;
      updateProductImage();
    });

    // 数量选项点击事件 (Buy 1 / Buy 2)
    $(document).on('click', '#sp-num .sp-option', function () {
      var $this = $(this);
      var $siblings = $('#sp-num .sp-option');
      var index = $siblings.index($this) + 1;

      // 更新选中状态
      $siblings.removeClass('active');
      $this.addClass('active');

      // 更新当前数量
      currentQty = index;
      updateProductImage();
    });

    // 套餐选项点击事件 (单品 / 套装)
    $(document).on('click', '#sp-size .sp-option', function () {
      var $this = $(this);
      var $siblings = $('#sp-size .sp-option');
      var index = $siblings.index($this) + 1;

      // 更新选中状态
      $siblings.removeClass('active');
      $this.addClass('active');

      // 更新当前套餐
      currentBundle = index;
      updateProductImage();
    });
  })();

  // 移动端底部购物车模块滚动显示
  (function initMobileFixedBottomShow() {
    var $fixedBottom = $('.sp-fixed-bottom');
    if ($fixedBottom.length === 0) return;

    var screenHeight = window.innerHeight;

    $(window).on('scroll', function () {
      var scrollTop = $(window).scrollTop();

      // 滑过首屏后显示
      if (scrollTop > screenHeight) {
        $fixedBottom.addClass('show');
      } else {
        $fixedBottom.removeClass('show');
      }
    });
  })();
});
